<div class="dropdown" (click)="toggleDropdown()">
  <span class="dropdown-text">{{ selectedOption || placeholder }}</span>
  <i class="arrow-down" *ngIf="options.length > 1"></i>
  <ul class="dropdown-menu" *ngIf="isOpen">
    <li *ngFor="let option of options" (click)="selectOption(option)">
      {{ option }}
    </li>
  </ul>
</div>
